import { createTheme, alpha } from "@mui/material/styles";
import { Theme } from "@mui/material";

import { red } from "@mui/material/colors";
import { ptBR } from "@mui/x-data-grid/locales";

const theme = createTheme(
  {
    typography: {
      fontFamily: "Inter",
      body1: {
        fontSize: "14px",
      },
      allVariants: {
        lineHeight: 1.3,
      },
    },
    palette: {
      mode: "dark",
      primary: {
        main: "#7600ED",
        light: "#DEBDFF",
        dark: "#5600AC",
        contrastText: "#FFFFFF",
      },
      secondary: {
        main: "#232323",
        "100": "#282828",
        light: "#2E2E2E",
        dark: "#161616",
        contrastText: "#A0A0A0",
      },
      error: {
        main: red.A400,
      },
      background: {
        default: "#232323",
      },
    },
    components: {
      MuiDialogContent: {
        styleOverrides: {
          root: {
            backgroundColor: "#232323",
          },
        },
      },
      MuiDialogActions: {
        styleOverrides: {
          root: {
            backgroundColor: "#232323",
          },
        },
      },
      MuiDialogTitle: {
        styleOverrides: {
          root: {
            backgroundColor: "#232323",
          },
        },
      },
      MuiToggleButton: {
        styleOverrides: {
          root: ({ theme }: { theme: Theme }) => ({
            "&.Mui-selected": {
              backgroundColor: theme.palette.primary.main,
              color: "white",
            },
          }),
        },
      },

      MuiDrawer: {
        styleOverrides: {
          paper: {
            "--Paper-overlay": "none !important",
            "--Paper-shadow": "none !important",
            backgroundImage: "none !important",
            boxShadow: "none !important",
            backgroundColor: "#232323",
          },
        },
      },

      MuiToolbar: {
        styleOverrides: {
          root: ({ theme }: { theme: Theme }) => ({
            minHeight: 42,
            height: 42,
            alignItems: "center",
            [theme.breakpoints.up("sm")]: {
              minHeight: 42,
            },
          }),
        },
      },

      MuiInputBase: {
        defaultProps: {
          size: "small",
          autoComplete: "off",
          style: {
            borderRadius: "8px",
          },
        },
        styleOverrides: {
          root: ({ theme }: { theme: Theme }) => ({
            marginTop: theme.spacing(3),
            borderRadius: "8px",
            position: "relative",
            border: "1px solid",
            fontSize: 16,
            width: "100%",
            transition: theme.transitions.create([
              "border-color",
              "background-color",
              "box-shadow",
            ]),
            "&:focus": {
              boxShadow: `${alpha(
                theme.palette.primary.main,
                0.25
              )} 0 0 0 0.2rem`,
              borderColor: theme.palette.primary.main,
            },
            ...(theme.palette.mode === "dark" && {
              backgroundColor: "#303033",
              borderColor: "#707075",
            }),
          }),
          input: {
            autoComplete: "off",
          },
        },
      },
      MuiButtonBase: {
        styleOverrides: {
          root: { fontWeight: 700, fontSize: 40 },
        },
      },
      MuiButton: {
        styleOverrides: {
          root: ({ theme }) => ({
            boxShadow: "none",
            borderRadius: 15,
            fontSize: "14px",
            fontWeight: 700,
            textTransform: "initial",
            variants: [
              {
                props: { size: "small" },
                style: {},
              },
              {
                props: {
                  size: "medium",
                },
                style: {
                  height: "32px",
                },
              },
              {
                props: {
                  size: "large",
                },
                style: {
                  height: "45px",
                },
              },
              {
                props: {
                  color: "primary",
                  variant: "contained",
                },
                style: { color: "#fff" },
              },
              {
                props: {
                  color: "success",
                  variant: "contained",
                },
                style: { color: "#fff" },
              },
              {
                props: {
                  color: "secondary",
                  variant: "contained",
                },
                style: {},
              },
              {
                props: {
                  variant: "outlined",
                },
                style: {},
              },
              {
                props: {
                  color: "secondary",
                  variant: "outlined",
                },
                style: {},
              },
              {
                props: {
                  variant: "text",
                },
                style: {},
              },
              {
                props: {
                  color: "secondary",
                  variant: "text",
                },
                style: {},
              },

              {
                props: {
                  color: "info",
                  variant: "contained",
                },
                style: {
                  backgroundColor: "#fff",
                  color: theme.palette.primary.main,
                },
              },
            ],
          }),
        },
      },
    },
  },
  ptBR
);

export default theme;
